var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AED136;}\n\t.st1{fill:#B1B1AD;}\n\t.st2{fill:#5F6F3D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M543.1,719h-497V0h497C714,0,850.6,135.8,850.6,305.5v108C850.6,583.2,714,719,543.1,719z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M670.5,1080H46.1V719c0-197.5,161.5-361,363.4-361h260.9c198.8,0,363.4,160.5,363.4,358   C1033.9,916.5,869.3,1080,670.5,1080z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M850.6,407.3v6.2C850.6,583.2,714,719,543.1,719h-497c0-98.7,40.4-188.2,105.6-256.1   C217,398,307,357.9,406.4,357.9h260.9C735.7,361,797.8,376.4,850.6,407.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoba);
export default __webpack_public_path__ + "static/media/boba.53152ec933c29600581893b5de758850.svg";
export { ForwardRef as ReactComponent };